import { render, staticRenderFns } from "./capital-data.vue?vue&type=template&id=21c70e5e&scoped=true&"
import script from "./capital-data.vue?vue&type=script&lang=js&"
export * from "./capital-data.vue?vue&type=script&lang=js&"
import style0 from "./capital-data.vue?vue&type=style&index=0&id=21c70e5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c70e5e",
  null
  
)

export default component.exports